import type { ApisauceInstance } from "apisauce";
import { DEFAULT_ENQUIRY_HR_STATUS, ENQUIRY_HR_UPDATE_ENDPOINT } from "./enquiry-settings";
import type { EnquiryHrComment, EnquiryHrRecord } from "./enquiry-hr-types";
import type { EnquiryRow } from "./enquiry-helpers";

const parseComment = (raw: unknown): EnquiryHrComment | null => {
    if (!raw || typeof raw !== "object") return null;
    const item = raw as Record<string, unknown>;
    const text = item.text ?? item.comment ?? item.comments;
    if (typeof text !== "string" || !text.trim()) return null;

    return {
        id: String(item.id ?? item.ts ?? `${text}-${item.createdAt ?? item.created_at ?? ""}`),
        text: text.trim(),
        author: String(item.author ?? item.who ?? item.user ?? item.name ?? "HR User"),
        createdAt: String(item.createdAt ?? item.created_at ?? item.ts ?? new Date().toISOString()),
    };
};

export const parseEnquiryHrRecord = (row: EnquiryRow): EnquiryHrRecord => {
    const record = row as Record<string, unknown>;
    const status =
        typeof record.hr_status === "string" && record.hr_status
            ? record.hr_status
            : typeof record.status === "string" && record.status
              ? record.status
              : DEFAULT_ENQUIRY_HR_STATUS;

    const rawComments = record.comments ?? record.hr_comments ?? record.timeline_log ?? [];
    const comments = Array.isArray(rawComments)
        ? rawComments.map(parseComment).filter((item): item is EnquiryHrComment => Boolean(item))
        : [];

    return { status, comments };
};

export const saveEnquiryHrToApi = async (
    api: ApisauceInstance,
    id: number,
    payload: { status?: string; comment?: string }
) => {
    const updated_fields: Record<string, unknown> = {};
    if (payload.status !== undefined) {
        updated_fields.status = payload.status;
    }
    if (payload.comment !== undefined) {
        updated_fields.comments = payload.comment;
    }

    return api.post(ENQUIRY_HR_UPDATE_ENDPOINT, {
        contact_id: id,
        updated_fields,
    });
};
